/* External dependencies */
import update from 'immutability-helper';

/* Local dependencies */
import { User } from '../../types';
import { GetUserAction, GetUserActionTypes } from './types';

export interface GetUsersState {
  user: User;
  error: Error;
  loading: boolean;
}

export const initialGetUserState: GetUsersState = {
  user: undefined,
  error: undefined,
  loading: false,
};

export default function getUserReducer(state = initialGetUserState, action: GetUserAction) {
  switch (action.type) {
    case GetUserActionTypes.GET_USER_REQUEST:
      return update(state, {
        loading: { $set: true },
      });

    case GetUserActionTypes.GET_USER_SUCCESS:
      return update(state, {
        loading: { $set: false },
        user: { $set: action.user },
      });

    case GetUserActionTypes.GET_USER_ERROR:
      return update(state, {
        error: { $set: action.error },
        loading: { $set: false },
      });

    default:
      return state;
  }
}
